import { Box, Typography } from "@mui/material";

export const MedicalStaffListToolbar = () => {
  return (
    <Box>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          m: -1,
        }}
      >
        <Typography
          sx={{ m: 1, fontSize: "1.45rem", color: "primary.dark" }}
          variant="h4"
        >
          Consulta de médicos
        </Typography>
      </Box>
    </Box>
  );
};
